<template>
  <CCard class="mb-3">
    <CCardHeader>Mapa de calor por dia y hora</CCardHeader>
    <CCardBody>
      <apexchart
        type="heatmap"
        height="360"
        :options="chartOptions"
        :series="chartSeries"
      />
      <div class="pt-2 text-muted small">
        Los valores se muestran aunque la muestra sea baja; valida el filtro "Minimo por franja" para mayor confiabilidad.
      </div>
    </CCardBody>
  </CCard>
</template>

<script>
import VueApexCharts from 'vue-apexcharts'

export default {
  name: 'SendTimeHeatmap',
  components: {
    apexchart: VueApexCharts,
  },
  props: {
    cells: {
      type: Array,
      default: () => [],
    },
    metric: {
      type: String,
      default: 'read_rate',
    },
  },
  data() {
    return {
      weekdays: [
        { value: 1, label: 'Lunes' },
        { value: 2, label: 'Martes' },
        { value: 3, label: 'Miercoles' },
        { value: 4, label: 'Jueves' },
        { value: 5, label: 'Viernes' },
        { value: 6, label: 'Sabado' },
        { value: 7, label: 'Domingo' },
      ],
    }
  },
  computed: {
    chartSeries() {
      const self = this
      return this.weekdays.map(function (weekday) {
        const data = []
        for (let hour = 0; hour <= 23; hour++) {
          const cell = self.cells.find(function (item) {
            return Number(item.weekday_iso) === Number(weekday.value) && Number(item.hour) === Number(hour)
          })

          const value = self.mapMetricValue(cell)
          data.push({
            x: self.formatHour(hour),
            y: value,
          })
        }

        return {
          name: weekday.label,
          data,
        }
      })
    },
    chartOptions() {
      const titleMap = {
        read_rate: 'Tasa de lectura (%)',
        response_rate: 'Tasa de respuesta (%)',
        delivery_rate: 'Tasa de entrega (%)',
        error_rate: 'Tasa de error (%)',
        sent_count: 'Mensajes enviados',
        avg_time_to_read: 'Tiempo a lectura (min)',
        avg_time_to_response: 'Tiempo a respuesta (min)',
      }

      return {
        chart: {
          toolbar: { show: false },
          foreColor: '#5c5648',
        },
        dataLabels: {
          enabled: false,
        },
        xaxis: {
          labels: {
            rotate: -45,
          },
        },
        plotOptions: {
          heatmap: {
            shadeIntensity: 0.45,
            radius: 2,
            colorScale: {
              ranges: this.colorRanges(),
            },
          },
        },
        tooltip: {
          y: {
            formatter: (value) => this.tooltipValue(value),
          },
        },
        grid: {
          borderColor: '#ece7d8',
        },
        title: {
          text: titleMap[this.metric] || 'Metrica',
          align: 'left',
          style: {
            fontSize: '12px',
            fontWeight: 500,
          },
        },
      }
    },
  },
  methods: {
    formatHour(hour) {
      return `${String(hour).padStart(2, '0')}:00`
    },
    mapMetricValue(cell) {
      if (!cell) {
        return 0
      }

      const raw = Number(cell.metric_value || 0)
      if (this.metric === 'avg_time_to_read' || this.metric === 'avg_time_to_response') {
        return Number(raw.toFixed(2))
      }

      if (this.metric === 'sent_count') {
        return Number(raw.toFixed(0))
      }

      return Number((raw * 100).toFixed(2))
    },
    tooltipValue(value) {
      if (this.metric === 'avg_time_to_read' || this.metric === 'avg_time_to_response') {
        return value.toFixed(1) + ' min'
      }

      if (this.metric === 'sent_count') {
        return Number(value).toLocaleString('es-MX')
      }

      return value.toFixed(1) + '%'
    },
    colorRanges() {
      if (this.metric === 'sent_count') {
        return [
          { from: 0, to: 5, color: '#f0ede5' },
          { from: 6, to: 25, color: '#d8d3c3' },
          { from: 26, to: 60, color: '#b8c7b4' },
          { from: 61, to: 100000, color: '#829b7c' },
        ]
      }

      if (this.metric === 'avg_time_to_read' || this.metric === 'avg_time_to_response') {
        return [
          { from: 0, to: 5, color: '#7ea36f' },
          { from: 5.01, to: 20, color: '#b6c79e' },
          { from: 20.01, to: 60, color: '#d8d3c3' },
          { from: 60.01, to: 100000, color: '#c9937a' },
        ]
      }

      return [
        { from: 0, to: 20, color: '#f0ede5' },
        { from: 20.01, to: 45, color: '#d8d3c3' },
        { from: 45.01, to: 70, color: '#b8c7b4' },
        { from: 70.01, to: 100, color: '#829b7c' },
      ]
    },
  },
}
</script>
